<div class="echarts" echarts [options]="chartOption" (chartClick)="onChartClick($event);"></div>
<div *ngIf="!graphData?.length" class="place-center h-100 no-data-style">No Data</div>